const initialState = {
    defaultRules: [],
    defaultRulesForSelectionBox: [],
    applicationRuleNames: [],
    applicationRulesNamesForSelectionBox: [],
    defaultMatchingTypes: [],
    sourceColumns: [],
    targetColumns: [],
    matchingMappings: [],
    predictedRule: [],
    llmConfigs: [],
};


export default initialState;